import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";
import Graphic from "@arcgis/core/Graphic";
import config from "../assets/config.json";
import * as locator from "@arcgis/core/rest/locator.js";

function retrieveLayer(webmap, layerTitle) {
     const layer = webmap.allLayers.find(
          (e) => e.title === layerTitle
     )
     return layer;
}

export async function handleExtensionActions(webmap, view, extensionData) {
     // console.log('handleExtensionActions, extensionData', extensionData);
     let sitesLayer = retrieveLayer(webmap, config.layerNames.sitesLayer.title);
     // the new grouping is called 'Sites', but so is the actual sites layer still. So the next if statement
     // is needed to ensure that the actual sites layer is the one that is assigned...
     if (sitesLayer.allLayers) {
          sitesLayer = sitesLayer.allLayers.find((e) => e.title === config.layerNames.sitesLayer.title);
     }
     await sitesLayer.load();
     const releaseLayer = retrieveLayer(webmap, config.layerNames.releases.title);
     const statesLayer = retrieveLayer(webmap, config.layerNames.statesLayer.title);
     const brownfieldLayer = retrieveLayer(webmap, config.layerNames.brownfieldLayer.title);
     const superfundLayers = [
          retrieveLayer(webmap, config.layerNames.superfundSiteBoundaries.title),
          retrieveLayer(webmap, config.layerNames.superfundOperableUnitBoundaries.title),
          retrieveLayer(webmap, config.layerNames.superfundInstitutionalControlBoundaries.title),
     ];
     const zipLayer = retrieveLayer(webmap, config.layerNames.zip.title);
     const regionsLayer = retrieveLayer(webmap, config.layerNames.regions.title);
     const countiesLayer = retrieveLayer(webmap, config.layerNames.counties.title);
     const layer = retrieveLayer(webmap, extensionData.layer);
     const didFail = await view.when(async () => {
          let result; // use result to check if any requests fail
          if (extensionData.type === 'layer') {
               await view.whenLayerView(layer).then((layerView) => {
                    layerAction(layerView, sitesLayer)
               });
          } else if (extensionData.type === 'state') {
               const where = `STATE_ABBR = '${extensionData.abbr}'`;
               result = await goToExtent(statesLayer, view, where);
               if (result !== 'success'){
                    return result;
               }
               result = await polygonAction(statesLayer, view, where);
               if (result !== 'success'){
                    return result;
               } else {
                    return 'success';
               }
          } else if (extensionData.type === 'zip') {
               const where = `ZIP_CODE = '${extensionData.zip}'`;
               result = await goToExtent(zipLayer, view, where);
               if (result !== 'success'){
                    return result;
               }
               result = await polygonAction(zipLayer, view, where);
               if (result !== 'success'){
                    return result;
               } else {
                    return 'success';
               }
          }  else if (extensionData.type === 'region') {
               const where = `EPAREGION = 'Region ${extensionData.region}'`;
               result = await goToExtent(regionsLayer, view, where);
               if (result !== 'success'){
                    return result;
               }
               result = await polygonAction(regionsLayer, view, where);
               if (result !== 'success'){
                    return result;
               } else {
                    return 'success';
               }
          } else if (extensionData.type === 'specific') {
               // construct where using quotes around string fields, but not on number fields
               const where = extensionData.property !== 'BF_PROPERTY_ID' ?
                    `${extensionData.attribute} = '${extensionData.property}'` :
                    `${extensionData.attribute} = ${extensionData.property}`;
               console.log('where', where);
               result = await goToPoint(sitesLayer, view, where);
               if (result !== 'success') {
                    return result;
               } else {
                    if (extensionData.attribute === 'SF_SITE_ID') {
                         toggleSuperfundLayers(superfundLayers);
                    }
                    return result;
               }
          } else if (extensionData.type === 'ustSpecific') {
               const where = `${extensionData.attribute} = '${extensionData.property}'`;
               result = await goToPoint(releaseLayer, view, where);
               if (result !== 'success') {
                    return result;
               } else {
                    releaseLayer.visible = true;
                    return result;
               }
          } else if (extensionData.type === 'superfundZoom') {
               const where = `SF_SITE_ID = '${extensionData.SF_SITE_ID}'`;
               // goToCustomZoom(layer, view, where, extensionData.zoomLevel);
               result = await goToCustomZoom(sitesLayer, view, where, extensionData.zoomLevel);
               if (result === 'error') return true;
               toggleSuperfundLayers(superfundLayers);
          } else if (extensionData.type === 'bfJurisdiction') {
               // use quotes if it's JURISDICTION_NAME, but not if it's JURISDICTION_ID
               const where = extensionData.attribute !== 'JURISDICTION_ID' ?
               `${extensionData.attribute} = '${extensionData.property}'` :
               `${extensionData.attribute} = ${extensionData.property}`;
               // turn off the sites layer view visibility
               try {
                    const sitesLayerView = await view.whenLayerView(sitesLayer);
                    sitesLayerView.visible = false;
                    sitesLayer.visible = false;
               } catch (e) {
                    // failed to turn off sites layer view visibility
                    return 'Error turning off sites layer visibility.';
               }
               result = await goToExtent(brownfieldLayer, view, where);
               if (result !== 'success'){
                    return result;
               }
               // set the bf layer view filter
               try {
                    // brownfieldLayer.visible = true;
                    const bfLayerView = await view.whenLayerView(brownfieldLayer);
                    // bfLayerView.filter = {
                    //      where: where
                    // }
                    bfLayerView.visible = true;
               } catch (e) {
                    // failed to set layer view filter for brownfield layer
                    return 'Error setting brownfield layer filter.';
               }
               // result = await polygonAction(brownfieldLayer, view, where);
               // if (result === 'error') return true;
          } else if (extensionData.type === 'latLong') {
               result = await goToLatLong(view, extensionData.property);
               if (result !== 'success'){
                    return result;
               } else {
                    return 'success';
               }
          } else if (extensionData.type === 'grantId') {
               result = await zoomToGrant(view, extensionData.property, brownfieldLayer, sitesLayer);
               // console.log('grantId', extensionData.property);
               if (result !== 'success'){
                    return result;
               } else {
                    return 'success';
               }
          } else if (extensionData.type === 'countyState') {
               // result = await zoomToGrant(view, extensionData.property, brownfieldLayer, sitesLayer);
               // console.log('grantId', extensionData.property);
               const where = `NAME = '${extensionData.county}' AND STATE_ABBR = '${extensionData.state}'`;
               result = await goToExtent(countiesLayer, view, where);
               if (result !== 'success'){
                    return result;
               }
               result = await polygonAction(countiesLayer, view, where);
               if (result !== 'success'){
                    return result;
               } else {
                    return 'success';
               }
          } else if (extensionData.type === 'cityState') {
               result = await cityStateSearch(view, extensionData);
               if (result !== 'success'){
                    return result;
               } else {
                    return 'success';
               }
          } else if (extensionData.type === 'singleLineGeocode') {
               result = await singleLineSearch(view, extensionData.location);
               if (result !== 'success'){
                    return result;
               } else {
                    return 'success';
               }
          } else if (extensionData.type === 'site') {
               console.log('sites def query: ', extensionData.where);
               sitesLayer.definitionExpression = extensionData.where;
          }
          // else {
          //      console.error('invalid route');
          //      return true;
          // }
          return 'success';
     });
     return didFail;
}

async function toggleSuperfundLayers(superfundLayers) {
     // toggle superfund layers visibility properties
     superfundLayers.forEach((layer) => {
          layer.visible = true;
     });
}

// geocode an address and zoom to the location
async function cityStateSearch(view, params) {
     try {
          console.log('find location params', {
               address: {
                    City: params.city,
                    Region: params.state
               }
          });
          const result = await locator.addressToLocations('https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer', {
               address: {
                    City: params.city,
                    Region: params.state
               }
          });
          if (result.length === 0) {
               return 'No location found. Please try a different search.';
          } else {
               view.goTo({
                    center: result[0].extent,
                    zoom: 12
               });
               return 'success';
          }
     } catch (e) {
          console.error('error with address', e);
          return 'Error zooming to address.';
     }
}

// geocode a free-form single-line location and zoom to the location
async function singleLineSearch(view, singleLineText) {
     try {
          const result = await locator.addressToLocations('https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer', {
               address: {singleLine: singleLineText},
               maxLocations: 1,
               outFields: ['*']
          });
          if (!result || result.length === 0) {
               return 'No location found. Please try a different search.';
          }
          const candidate = result[0];
          if (candidate.extent) {
               await view.goTo(candidate.extent);
          } else if (candidate.location) {
               await view.goTo({ center: [candidate.location.x, candidate.location.y], zoom: 12 });
          } else {
               return 'No valid geometry returned from geocoder.';
          }
          return 'success';
     } catch (e) {
          console.error('error with single-line geocode', e);
          return 'Error zooming to location.';
     }
}

// zoom to lat long
async function goToLatLong(view, latLong) {
     try {
          view.goTo({
               center: [parseFloat(latLong.long), parseFloat(latLong.lat)],
               zoom: 15
          });
          return 'success';
     } catch (e) {
          console.error('error with lat long', e);
          return 'Error zooming to latitude and longitude.';
     }
}

// for all sites in general
async function goToPoint(layer, view, where) {
     let results = {};
     try {
          results = await layer.queryFeatures({
               where: where,
               outFields: ["*"],
               returnGeometry: true
          });
          if (results.features.length === 0) {
               return 'No features found. Please try a different search.';
          }
     } catch (e) {
          console.error('error with query');
          return 'Error finding feature.';
     }
     try {
          if (results.features.length > 1) {
               view.goTo({
                    center: results.features
               });
          } else {
               view.goTo({
                    center: [results.features[0].geometry.longitude, results.features[0].geometry.latitude],
                    zoom: 15
               });
               openPopup(view, results.features);
          }
          return 'success';
     } catch (e) {
          console.error('error finding feature', e);
          return 'Can not zoom to feature.';
     }
}

// for superfund searching with custom zoom
async function goToCustomZoom(layer, view, where, zoomLevel) {
     let results = {};
     try {
          results = await layer.queryFeatures({
               where: where,
               outFields: ['*'],
               returnGeometry: true
          });
     } catch (e) {
          console.error('error with query', e);
          return 'error';
     }
     try {
          view.goTo({
               center: [results.features[0].geometry.longitude, results.features[0].geometry.latitude],
               zoom: zoomLevel
          });
          openPopup(view, results.features);
          return 'success';
     } catch (e) {
          console.error('error finding feature');
          return 'error';
     }
}

function openPopup(view, features) {
     try {
          view.popup.open({
               features: features
          });
     } catch (e) {
          console.error('Could not open popup');
     }
}

async function goToExtent(layer, view, where) {
     let results = {};
     try {
          results = await layer.queryFeatures({
               where: where,
               returnGeometry: true
          });
          if (results.features.length === 0) {
               return 'No features found. Please try a different search.';
          }
     } catch (e) {
          console.error('could not complete query', e);
          return 'Error querying brownfield grants layer.';
     }
     if (results.features) {
          try {
               const extent = results.features[0].geometry.extent;
               view.extent = extent;
               return 'success';
          } catch (e) {
               console.error('could not set extent');
               return 'Error setting map extent.';
          }
     }
}

function layerAction(layerView, sitesLayer) {
     try {
          layerView.layer.visible = true;
          layerView.visible = true;
          sitesLayer.visible = false;
     } catch (e) {
          console.error('Could not toggle layer view');
     }
}

async function polygonAction(layer, view, where) {
     let results = {};
     try {
          results = await layer.queryFeatures({
               where: where,
               returnGeometry: true
          });
          if (results.features.length > 0) {
               const graphic = new Graphic({
                    geometry: results.features[0].geometry,
                    symbol: new SimpleFillSymbol({
                         color: [173, 173, 173, 0.50]
                    })
               });
               view.graphics.add(graphic);
          }
          return 'success';
     } catch (e) {
          console.error('error creating graphic', e);
          return 'error';
     }

}

async function zoomToGrant(view, query, brownfieldLayer, sitesLayer) {
     try {
          const where = `GRANT_ID = ${query.grantId}`;
          const grantsTable = view.map.tables.find((table) => table.title === config.tableNames.brownfieldTable.title);
          const grantResult = await grantsTable.queryFeatures({
               where: where,
               returnGeometry: false,
               outFields: ['OBJECTID', 'GRANT_ID']
          });
          if (grantResult.features.length === 0) {
               return 'No grant found with that ID. Please try a different search.';
          } else {
               const grantObjectId = grantResult.features[0].attributes.OBJECTID;
               const grantFeature = await grantsTable.queryRelatedFeatures({
                    relationshipId: 0,
                    objectIds: [grantObjectId],
                    outFields: ['*'],
                    returnGeometry: true
               });
               if (Object.keys(grantFeature).length === 0) {
                    return 'Could not find the related grant jurisdiction boundary. Please try a different search.';
               } else {
                    const grantGeometry = grantFeature[grantObjectId].features[0];
                    view.goTo(grantGeometry.geometry);
                    toggleLayerVisibility(brownfieldLayer, sitesLayer);
                    return 'success';
               }
          }
     } catch (e) {
          console.error('error setting filter', e);
          return 'Error setting brownfield grants layer filter.';
     }
}

function toggleLayerVisibility(brownfieldLayer, sitesLayer) {
     brownfieldLayer.visible = true;
     sitesLayer.visible = false;
}